import React from "react";

const Footer = () => {
  return (
    <footer
      style={{
        width: "100%",
        background: "transparent",
        color: "#fff",
        padding: "24px 0 18px 0",
        fontSize: 15,
        fontWeight: 500,
        letterSpacing: 0.2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        position: "relative",
        bottom: 0,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 24 }}>
        <span style={{ fontWeight: 700, marginLeft: 15 }}>
          <a
            href="https://www.property-assist.be"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#fff", textDecoration: "none" }}>
            Property Assist
          </a>
        </span>
        <a
          href="https://www.property-assist.be/terms"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#fff",
            margin: "0 12px",
            textDecoration: "none",
            opacity: 0.85,
          }}
        >
          CGU
        </a>
        <a
          href="https://www.property-assist.be/contactus"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "#fff",
            margin: "0 12px",
            textDecoration: "none",
            opacity: 0.85,
          }}
        >
          Contactez-nous
        </a>
      </div>
      <span style={{ fontSize: 13, opacity: 1, marginRight: 15 }}>
        Développé par{" "}
        <a
          href="https://www.oosmose.com"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#fff", textDecoration: "none" }}
        >
          <b>Ooosmose Properties</b>
        </a>
      </span>
    </footer>
  );
};

export default Footer;
